export const InputDisable = ({ label, id, value }) => {
  return (
    <div className="mb-3 w-full">
      <label
        htmlFor={id}
        className="block mb-1 text-primary text-f14 font-semibold text-left"
      >
        {label}
      </label>
      <input
        type="text"
        id={id}
        value={value}
        disabled={true}
        className={`w-full focus:border-primary px-3 py-2 border border-input rounded
          bg-lightGray
        `}
      />
    </div>
  );
};
